import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import useResourceForm from "./useResourceForm";
import { Typography } from "@material-ui/core";

const defaultData = {
  name: "",
  location: "",
  author: "",
  year: "",
  referenceType: null,
};

const styles = () => ({
  root: {
    padding: 8,
    maxWidth: 774,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

const ResourceForm = ({ disabled, onFormChange, initialData, classes, editmode }) => {
  const [data, setData] = React.useState(initialData || defaultData);
  const {
    dataSources,
    getReferenceTypes
  } = useResourceForm();
  const {
    name,
    location,
    author,
    year,
    referenceType
  } = data;

  useEffect(() => {
    getReferenceTypes();
  }, []);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>Параметры ресурса</Typography>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            value={name}
            onChange={e => onChange("name", e.target.value)}
            label="Название"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={location}
            onChange={e => onChange("location", e.target.value)}
            label="Расположение"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={author}
            onChange={e => onChange("author", e.target.value)}
            label="Автор/Составитель"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            value={year}
            onChange={e => onChange("year", e.target.value)}
            label="Год"
            disabled={disabled}
            readOnly={!editmode}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <DataSelect
            value={referenceType}
            onChange={value => onChange("referenceType", value.id)}
            label="Вид ресурса"
            dataSource={dataSources.referenceTypes}
            disabled={disabled || !editmode}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(ResourceForm);
